module.exports = __webpack_public_path__ + "img/gps-table-icon.9dc61f29.svg";